import { Link } from 'react-router-dom';
import { movies } from '@/mocks/data';

interface MovieCardProps {
  id: string;
}

const movieArticleMap: Record<string, string> = {
  parasite: 'bong-joon-ho-narrative-evolution',
  oldboy: 'park-chan-wook-revenge-trilogy',
  'the-wailing': 'korean-horror-folklore-the-wailing',
  'the-handmaiden': 'the-handmaiden-female-gaze',
  burning: 'lee-chang-dong-burning-existential-crisis',
  'a-taxi-driver': 'taxi-driver-democratization-narrative',
};

export default function MovieCard({ id }: MovieCardProps) {
  const movie = movies.find((m) => m.id === id);
  if (!movie) return null;

  const articleSlug = movieArticleMap[id] || 'bong-joon-ho-narrative-evolution';

  return (
    <Link
      to={`/article/${articleSlug}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={movie.posterUrl}
          alt={movie.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <p className="text-sm text-white/90 leading-relaxed line-clamp-4">{movie.summary}</p>
        </div>
        <div className="absolute top-2 right-2 bg-primary-500 text-white text-xs font-bold px-2 py-1 rounded-md">
          {movie.rating}
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">
          {movie.director} · {movie.year}
        </p>
      </div>
    </Link>
  );
}

export { movieArticleMap };